import { ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';
import { DateTimeProperty, EnumProperty, StringProperty } from '../properties';
import { BeamSchema } from './BeamSchema';
import { BuildingSchema } from './BuildingSchema';
import { CeilingPlaneSchema } from './CeilingPlaneSchema';
import { CeilingTraySchema } from './CeilingTraySchema';
import { ComponentDesignSchema } from './ComponentDesignSchema';
import { FeaturePatternContainerSchema } from './FeaturePatternContainerSchema';
import { RoofContainerSchema } from './RoofContainerSchema';
import { RoofPlaneSchema } from './RoofPlaneSchema';
import { SnappingUnderlaySchema } from './SnappingUnderlaySchema';
import { TrussEnvelopeSchema } from './TrussEnvelopeSchema';
import { TrussGroupSchema } from './TrussGroupSchema';
import { WallSchema } from './WallSchema';
import { WorkLineSchema } from './WorkLineSchema';

const regions = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Puerto Rico',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const ProjectSchema = new GenericModelSchema('project', {
  category: ModelCategory.Project,

  children: {
    buildingInsertions: BuildingSchema,
    componentDesignInsertions: ComponentDesignSchema,

    // When adding new layout mode-specific children here, make sure you also configure the filters in `normalize` and
    //   `CreateModelButton` to prevent them from showing up in and/or breaking the project client.
    roofPlanes: RoofPlaneSchema,
    ceilingPlanes: CeilingPlaneSchema,
    ceilingTrays: CeilingTraySchema,
    roofContainers: RoofContainerSchema,
    featurePatternContainers: FeaturePatternContainerSchema,
    beams: BeamSchema,
    walls: WallSchema,
    trussEnvelopes: TrussEnvelopeSchema,

    trussGroups: TrussGroupSchema,

    workLines: WorkLineSchema,
    snappingUnderlays: SnappingUnderlaySchema,
  },

  displayName: (item) => item.name,

  properties: {
    name: StringProperty.configure({ required: true }),

    createdAt: DateTimeProperty.configure({ readOnly: true }),

    organization: StringProperty.configure({ readOnly: true, required: true }),

    region: EnumProperty.configure({
      enum: regions,
      formatter: (region) => region,
      required: false,
      allowUnknownValues: true, // Value is unknown if the region has not been set
    }),
    contactName: StringProperty.configure({ required: true }),
    contactPhone: StringProperty.configure({ required: true }),
    contactEmail: StringProperty.configure({ required: true }),
    customerName: StringProperty,
    lotNumber: StringProperty,
    address: StringProperty,
    city: StringProperty,
    subdivision: StringProperty,
    model: StringProperty,
    // TODO: support grouping related fields
    buildingDesignerName: StringProperty,
    buildingDesignerAddress: StringProperty,
    buildingDesignerCity: StringProperty,
    buildingDesignerState: StringProperty,
    buildingDesignerLicenseNumber: StringProperty,
    // TODO: design settings
    projectSalesman: StringProperty,
  },
});
